module.exports = __webpack_public_path__ + "static/article1-381ceae74debf65a8d921691d95b64d3.png";